import { PLYWOOD_EXPENSES_FAILED, PLYWOOD_EXPENSES_REQUEST, PLYWOOD_EXPENSES_SUCCESS } from "app/redux/actions/Master/Expenses/PlywoodExpenses/constant";


const INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null
    }
};

export const plywoodExpensesReducer = function (state = INIT_STATE, action) {
    switch (action?.type) {
        case PLYWOOD_EXPENSES_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case PLYWOOD_EXPENSES_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case PLYWOOD_EXPENSES_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};